// Font Awesome functionality
import { library, dom } from '@fortawesome/fontawesome-svg-core';
import {
  faFacebook,
  faFoursquare,
  faGoogle,
  faInstagram,
  faLinkedin,
  faMedium,
  faPinterest,
  // faTripadvisor,
  faTwitter,
  faUntappd,
  faVimeo,
  faYelp,
  faYoutube,
} from '@fortawesome/free-brands-svg-icons'

// Deep import so we don't need to import and tree/shake the whole collection
// -- Solid
import { faArrowLeft } from '@fortawesome/pro-solid-svg-icons/faArrowLeft'
import { faArrowRight } from '@fortawesome/pro-solid-svg-icons/faArrowRight'
import { faCameraRetro } from '@fortawesome/pro-solid-svg-icons/faCameraRetro'
import { faChevronUp } from '@fortawesome/pro-solid-svg-icons/faChevronUp'
import { faCircle } from '@fortawesome/pro-solid-svg-icons/faCircle'
import { faLink } from '@fortawesome/pro-solid-svg-icons/faLink'
import { faPlus } from '@fortawesome/pro-solid-svg-icons/faPlus'
import { faMinus } from '@fortawesome/pro-solid-svg-icons/faMinus'
import { faAngleLeft } from '@fortawesome/pro-solid-svg-icons/faAngleLeft';
import { faAngleRight } from '@fortawesome/pro-solid-svg-icons/faAngleRight';
import { faAlignJustify } from '@fortawesome/pro-solid-svg-icons/faAlignJustify';
import { faMapMarkerAlt } from '@fortawesome/pro-solid-svg-icons/faMapMarkerAlt';
import { faRedo } from '@fortawesome/pro-solid-svg-icons/faRedo';
import { faRoad } from '@fortawesome/pro-solid-svg-icons/faRoad';
import { faCalendarAlt } from '@fortawesome/pro-solid-svg-icons/faCalendarAlt';
import { faTicket } from '@fortawesome/pro-solid-svg-icons/faTicket';
import { faHeadphones } from '@fortawesome/pro-solid-svg-icons/faHeadphones';
import { faShare } from '@fortawesome/pro-solid-svg-icons/faShare';

// -- Regular
import { faFile } from '@fortawesome/pro-regular-svg-icons/faFile'
import { faPlayCircle } from '@fortawesome/pro-regular-svg-icons/faPlayCircle'
import { faEnvelope } from '@fortawesome/pro-regular-svg-icons/faEnvelope'
import { faClock } from '@fortawesome/pro-regular-svg-icons/faClock';

// add the imported icons to the library
library.add(
  faFacebook,
  faFoursquare,
  faGoogle,
  faInstagram,
  faLinkedin,
  faMedium,
  faPinterest,
  faTwitter,
  faUntappd,
  faVimeo,
  faYelp,
  faYoutube,
  faArrowLeft,
  faArrowRight,
  faCameraRetro,
  faChevronUp,
  faCircle,
  faLink,
  faPlus,
  faMinus,
  faFile,
  faPlayCircle,
  faAngleLeft,
  faAngleRight,
  faAlignJustify,
  faClock,
  faMapMarkerAlt,
  faRedo,
  faRoad,
  faCalendarAlt,
  faTicket,
  faHeadphones,
  faEnvelope,
  faShare
);

// Import v4 shims
import '@fortawesome/fontawesome-free/js/v4-shims'

// tell FontAwesome to watch the DOM and add the SVGs when it detects icon markup
dom.watch();



// WEBPACK FOOTER //
// ./scripts/autoload/_fontawesome.js